module.exports = __webpack_public_path__ + "img/bg1s.4b68b492.png";